// report-map-entity.model.ts
import * as Cesium from 'cesium';
import { BaseMapEntity } from './base-map-entity.service';
import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataContextService } from './data-context.service';
import { TimelineService } from './timeline.service';

export class ReportMapEntity extends BaseMapEntity {
  override id: string;
  override name: string;
  override layerPath: string;
  iconUrl: string;
  latitude: number;
  longitude: number;
  altitude: number;
  override timestamp: Date;
  declare cesiumEntity: any;
  declare source: string;
  description?: string;

  constructor(
    id: string,
    name: string,
    layerPath: string,
    iconUrl: string,
    latitude: number,
    longitude: number,
    altitude: number = 0,
    timestamp: Date,
    source: string = '',
    cameraService: CameraService,
    coreService: CoreService,
    windowService: WindowService,
    dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService,
  ) {
    super(name, layerPath,cameraService,coreService,windowService,dataContext,modalService,timelineService);
    this.id = id;
    this.name = name;
    this.layerPath = layerPath;
    this.iconUrl = iconUrl;
    this.latitude = latitude;
    this.longitude = longitude;
    this.altitude = altitude;
    this.timestamp = timestamp;
    this.source = source;
    this.setIcon(iconUrl);
  }

  override setTimestamp(timestamp: Date) {
    this.timestamp = timestamp;
  }

  override getTimestamp(): Date {
    return this.timestamp;
  }

  override setSource(source: string) {
    this.source = source;
  }

  override getSource(): string {
    return this.source;
  }

  override getCesiumEntity(): any {
    if (!this.cesiumEntity) {
      this.buildEntity();
    }
    return this.cesiumEntity;
  }

  public override buildEntity(): void {
    this.cesiumEntity = {
      id: this.id,
      name: this.name,
      position: Cesium.Cartesian3.fromDegrees(this.longitude, this.latitude, this.altitude),
      billboard: {
        image: this.iconUrl,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        scale: 0.75,
        heightReference: Cesium.HeightReference.NONE
      },
      description: this.description || (this.source ? `Source: ${this.source}` : undefined)
    };
    this.cesiumEntity.arcLiveMapEntity = this;
  }

  override showInOverlappingEntitiesUI(): boolean {
    return true;
  }

  setDescription(description: string) {
    this.description = description;
  }
}